var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 70,
    viewBox: "0 0 95 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 15,
    width: 77,
    height: 55,
    rx: 6,
    fill: "#FC9C9C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 14.6392V7.00001C21 3.6863 23.6863 1 27 1H88C91.3137 1 94 3.68629 94 7V44C94 47.3137 91.3137 50 88 50H74.9789",
    stroke: "#1C1919",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 23L34.2113 44.4566C36.4203 46.231 39.5694 46.2183 41.764 44.4261L68 23",
    stroke: "#1C1919",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailIcon);
export default __webpack_public_path__ + "static/media/mailIcon.515bf23fabe283eb3477962595c07bd0.svg";
export { ForwardRef as ReactComponent };